<template>
  <el-container class="PrintConfig">
    <el-main class="p-0 pb-default">
      <ACheckboxYN
        v-model="is_private_config"
        @change="handleChangePrivateConfig"
      >개인 PC 설정</ACheckboxYN>
      <AHelper>개인 PC에 별도로 설정하시려면 체크하세요.</AHelper>
      <table class="w-full border" cellspacing="0">
        <col />
        <col width="80" />
        <col width="80" />
        <tr>
          <th>분 류</th>
          <th>좌측여백</th>
          <th>상단여백</th>
        </tr>
        <tr>
          <th>품질보증서</th>
          <td><ANumberInput size="small" v-model="data.warranty.margin_left"/></td>
          <td><ANumberInput size="small" v-model="data.warranty.margin_top"/></td>
        </tr>
        <tr>
          <th>컨트롤스티커</th>
          <td><ANumberInput size="small" v-model="data.control.margin_left"/></td>
          <td><ANumberInput size="small" v-model="data.control.margin_top"/></td>
        </tr>
        <tr>
          <th>박스스티커</th>
          <td><ANumberInput size="small" v-model="data.box.margin_left"/></td>
          <td><ANumberInput size="small" v-model="data.box.margin_top"/></td>
        </tr>
        <tr>
          <th>출고스티커</th>
          <td><ANumberInput size="small" v-model="data.out.margin_left"/></td>
          <td><ANumberInput size="small" v-model="data.out.margin_top"/></td>
        </tr>
      </table>
    </el-main>
    <el-footer> 
      <el-button
        type="primary"
        @click="handleClickRegister"
      >{{$t('button.register')}}</el-button>     
      <el-button @click="handleCloseDialog" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import { print_config } from '@/common/mixins/print_config'

export default {
  name: "PrintConfig",
  mixins: [print_config],
  data() {
    return {
      is_private_config: 'N',
      data: {
        warranty: {
          margin_left: 0,
          margin_top: 0,
        },
        control: {
          margin_left: 0,
          margin_top: 0,
        },
        box: {
          margin_left: 0,
          margin_top: 0,
        },
        out: {
          margin_left: 0,
          margin_top: 0,
        },
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let item = this.loadPrintConfig();
      if (!item) { return; }
      if (item.use) {
        this.is_private_config = "Y";
      }
      this.util.copyObject(item.value, this.data);
    },
    handleClickRegister() {
      if (this.is_private_config === 'Y') {
        this.updatePrintPrivateConfig(this.data);
        this.handleResponse({error: this.system.noError});
      } else {
        this.updatePrintGlobalConfig(this.data, this.handleResponse);
      }
    },
    handleResponse(res) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, '저장되었습니다.');
      this.handleCloseDialog();
    },
    handleCloseDialog() {
      this.$emit('completed');
    },
    handleChangePrivateConfig(value) {
      let item = null;
      if (value === 'Y') {
        item = this.loadPrintPrivateConfig();
      }
      if (!item) {
        item = this.loadPrintGlobalConfig();
      }
      if (!item) { return; }
      this.util.copyObject(item.value, this.data);
    }
  }
}
</script>
